import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchListByIdQuery = gql`
  query getListById($id: Long!) {
    list(id: $id) {
      name
      id
    }
  }
`;

export const useGetListResourceData = (id: number) => {
  const {
    data = {},
    isLoading,
    error,
  } = useGraphql(fetchListByIdQuery, {
    variables: { id },
  });

  return {
    resource: data.list || {},
    isLoading,
    hasError: !!error,
  };
};
